(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCollectionHero(scope) {
    (scope || document).querySelectorAll('.collection-hero__sets').forEach(function (wrap) {
      // Teardown previous timers/listeners so re-inits don't stack
      if (wrap._chTimer) { clearInterval(wrap._chTimer); wrap._chTimer = null; }
      clearTimeout(wrap._chResume);
      if (wrap._chSuspend) {
        ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
          wrap.removeEventListener(ev, wrap._chSuspend);
        });
        wrap._chSuspend = null;
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        // Mobile: sliding carousel — each card slides out left as the next
        // slides in from the right, advancing once per second.
        var cards = wrap.querySelectorAll('product-component, .collection-hero__placeholder');
        if (cards.length < 2) return;
        var step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
        if (!step) { step = wrap.clientWidth; }
        var idx = 0;
        function play() {
          if (wrap._chTimer) clearInterval(wrap._chTimer);
          wrap._chTimer = setInterval(function () {
            idx = (idx + 1) % cards.length;
            wrap.scrollTo({ left: Math.round(idx * step), behavior: 'smooth' });
          }, 2000);
        }
        // Suspend on manual interaction; resume 4s after the last interaction
        wrap._chSuspend = function () {
          if (wrap._chTimer) { clearInterval(wrap._chTimer); wrap._chTimer = null; }
          clearTimeout(wrap._chResume);
          wrap._chResume = setTimeout(function () {
            idx = Math.round(wrap.scrollLeft / step) % cards.length;
            play();
          }, 4000);
        };
        ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
          wrap.addEventListener(ev, wrap._chSuspend, { passive: true });
        });
        play();
        return;
      }

      // Desktop: crossfade sets of 4
      var sets = wrap.querySelectorAll('.collection-hero__set');
      if (sets.length < 2) return;
      var i = 0;
      sets.forEach(function (s, ix) { if (s.classList.contains('is-active')) i = ix; });
      var interval = parseInt(wrap.dataset.interval, 10) || 4000;
      wrap._chTimer = setInterval(function () {
        sets[i].classList.remove('is-active');
        i = (i + 1) % sets.length;
        sets[i].classList.add('is-active');
      }, interval);
    });
  }
  if (document.readyState !== 'loading') {
    initCollectionHero();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initCollectionHero(); });
  }
  document.addEventListener('shopify:section:load', function (e) { initCollectionHero(e.target); });
  var _chResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_chResizeTimer);
    _chResizeTimer = setTimeout(function () { initCollectionHero(); }, 200);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroProduct(scope) {
    (scope || document).querySelectorAll('.hero-product__slideshow').forEach(function (show) {
      var slides = show.querySelectorAll('.hero-product__slide');
      if (slides.length < 2) return;
      // Always clear a prior timer so only ONE interval runs per slideshow,
      // no matter how many times init fires (load, section:load, etc.).
      if (show._hpTimer) clearInterval(show._hpTimer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      slides.forEach(function (s, idx) { if (s.classList.contains('is-active')) i = idx; });
      var interval = parseInt(show.dataset.interval, 10) || 3000;
      show._hpTimer = setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }
  if (document.readyState !== 'loading') {
    initHeroProduct();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initHeroProduct(); });
  }
  document.addEventListener('shopify:section:load', function (e) { initHeroProduct(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Only behaviour left in JS is click-to-play for external (YouTube/Vimeo) videos.
  function initTestimonials(scope) {
    (scope || document).querySelectorAll('.testimonials__marquee .tcard__video-trigger').forEach(function (btn) {
      if (btn._tstBound) return;
      btn._tstBound = true;
      btn.addEventListener('click', function () {
        var type = btn.dataset.videoType, id = btn.dataset.videoId, url = btn.dataset.videoUrl, src = '';
        if (type === 'youtube') { src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0'; }
        else if (type === 'vimeo') { src = 'https://player.vimeo.com/video/' + id + '?autoplay=1'; }
        else { src = url; }
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Testimonial video');
        btn.replaceWith(iframe);
      });
    });
  }
  if (document.readyState !== 'loading') { initTestimonials(); }
  else { document.addEventListener('DOMContentLoaded', function () { initTestimonials(); }); }
  document.addEventListener('shopify:section:load', function (e) { initTestimonials(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
